import React from 'react';
import styled from 'styled-components';

export const AIDemoSection = () => {
  return (
    <Section>
      <Content>
        <Heading>Test Out Our AI Facilitators Right Now</Heading>
        <Subtext>Experience the power of AI with a live demo and see how it can enhance your business.</Subtext>
        {/* <CTAButton href="#">Try It Now</CTAButton> */}
      </Content>
    </Section>
  );
};

const Section = styled.section`
//   background-color: #034C53;
  color: #034C53;
  text-align: center;
  padding: 60px 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  
`;

const Content = styled.div`
  max-width: 600px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
`;

const Heading = styled.h1`
font-family: 'Clash Grotesk', sans-serif;
font-style: normal;
font-weight: 500;
        
color:#184A2C;
font-size: 56px;

text-align: center;
margin:0;
`;

const Subtext = styled.p`
  font-size: 18px;
  font-weight: 400;
  opacity: 0.9;
  font-family: raritas, sans-serif;
font-style: normal;

        
`;

const CTAButton = styled.p`
  background-color: #66BFBF;
  color: #034C53;
  padding: 12px 24px;
  font-size: 18px;
  border-radius: 8px;
  text-decoration: none;
  font-weight: 600;
  transition: 0.3s ease;

  &:hover {
    background-color: #EEF1DA;
  }
`;
